<template>
  <div class="page-box">
    <div class="nav-search">
      <div class="nav-search-top justify-center align-center">
        <div class="common-container justify-between align-center">
          <div class="nav-search-top-item-small">
            欢迎访问{{
              $wangzhan.name == "安徽"
                ? "安徽省心理学会"
                : $wangzhan.name + "心理咨询师协会"
            }}！今天 是{{ datetime }}
          </div>
          <div class="nav-search-top-item align-center" v-if="login_status">
            <span @click="outLogin()">退出登录</span
            >&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="renew()" v-if="tab === '0'"
              >续费</span
            >
          </div>
          <div class="nav-search-top-item align-center" v-else>
            <span @click="jumpLogin(0)">登录</span
            >&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="jumpLogin(1)">会员注册</span
            >&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="jumpLogin(3)"
              >会员单位注册</span
            >
          </div>
        </div>
      </div>
      <div class="nav-search-bottom justify-center align-center">
        <div class="common-container justify-between align-center">
          <img class="nav-logo" :src="$baseUrl + llll.logo" alt />
          <div
            class="search-input justify-between"
            @click="jumpRouter('/searchPage')"
            v-if="$route.path != '/searchPage'"
          >
            <input type="text" placeholder="请输入" />
            <div class="search-input-btn justify-center align-center">
              <i class="el-icon-search"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-tabbar justify-center">
      <div
        class="nav-tabbar-item f-w"
        v-for="(item, index) in tabbar_list"
        :key="index"
      >
        <div
          class="nav-tabbar-item-original justify-center align-center"
          :class="selfPath == item.path ? 'nav-tabbar-item-select' : ''"
          @click="jumpRouter(item.path)"
          v-if="item.path != '/matrixPage' || identity == 'admin'"
        >
          {{ item.title }}
        </div>
        <div v-if="'child' in item" class="nav-tabbar-item-list">
          <div
            v-for="(item2, index2) in item.child"
            :key="index2"
            class="nav-tabbar-item-list-child justify-center align-center"
            @click="jumpRouter(item.path, item2.id)"
          >
            {{ item2.name }}
          </div>
        </div>
      </div>
    </div>

    <router-view :key="$route.path + $route.query.id"></router-view>

    <div class="nav-footer flex-col justify-center align-center">
      <div class="nav-footer-action common-container justify-between">
        <div class="footer-logo-box flex-col">
          <img src="../assets/img/footer-logo.png" alt />
          <span @click="jumpLogin(2)" style="cursor: pointer">基地登录</span>
          <span>{{ llll.copyrightNo || "" }}</span>
          <a href="http://beian.miit.gov.cn" target="_blank"
            >备案号 : {{ llll.recordNo || "" }}</a
          >
          <span
            >{{ this.$wangzhan.name == "安徽" ? "学会地址" : "协会地址" }} ：{{
              llll.real_address || ""
            }}</span
          >
        </div>
        <div class="footer-code-box flex-col align-center">
          <img :src="$baseUrl + llll.twoDimensionalCode" alt />
        </div>
      </div>
    </div>
    <el-dialog
      title="微信扫描二维码支付会费"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="20%"
      :before-close="handleClose"
    >
      <div ref="qrCodeUrl" style="display: none"></div>
      <div ref="qrCodeUrl2"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="zhifuFun()">支付完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { outloginApi, renew ,queryOrder } from "@/api/g_login";
import { getForm } from "@/api/gwxx";
import QRCode from 'qrcodejs2'

export default {
  props: ["datetime"],
  data() {
    return {
      login_status: localStorage.getItem("foregroundToken"),
      selfPath: "/indexPage",
      tabbar_list: [
        {
          title: "首页",
          path: "/indexPage",
        },
        {
          title: this.$wangzhan.name == "安徽" ? "学会概况" : "协会概况",
          path: "/surveyPage",
          child: [
            {
              name: this.$wangzhan.name == "安徽" ? "学会简介" : "协会简介",
              id: "1",
            },
            {
              name: this.$wangzhan.name == "安徽" ? "学会章程" : "协会章程",
              id: "2",
            },
            { name: "组织机构", id: "3" },
            { name: "理事会", id: "4" },
          ],
        },
        {
          title: "新闻动态",
          path: "/newsPage",
          child: [
            {
              name: this.$wangzhan.name == "安徽" ? "学会动态" : "协会简介",
              id: "1",
            },
            { name: "通知公告", id: "2" },
            { name: "行业新闻", id: "3" },
          ],
        },
        {
          title: "课程与活动",
          path: "/coursePage",
        },
        {
          title: "学术交流",
          path: "/sciencePage",
        },
        {
          title: "科学普及",
          path: "/popularizationPage",
        },
        {
          title: "会员中心",
          path: "/memberPage",
          child: [
            { name: "证书查询", id: "1" },
            { name: "会员查询", id: "2" },
          ],
        },
        {
          title: "培训基地管理",
          path: "/matrixPage",
          child: [
            { name: "考试管理", id: "1" },
            // {name:'培训基地',id:'2'},
          ],
        },
        {
          title: this.$wangzhan.name == "安徽" ? "学会党建" : "协会党建",
          path: "/associationPage",
          child: [{ name: "党建", id: "1" }],
        },
        {
          title: "互动交流",
          path: "/interactPage",
          child: [{ name: "联系方式", id: "1" }],
        },
      ],
      identity: localStorage.getItem("identity"),
      llll: {},
      tab: "",
      dialogVisible: false,
      orderNo: "",
    };
  },

  mounted() {
    this.selfPath = this.$route.path;
    getForm().then((res) => {
      this.llll = JSON.parse(res.data);
    });

    this.tab = localStorage.getItem("tab");
    console.log("pc端tab", this.tab);
  },
  watch: {
    $route(to) {
      this.selfPath = to.path;
    },
  },
  methods: {
    jumpRouter(path, id = 1) {
      this.$router.push({ path, query: { id: id } });
      this.selfPath = path;
    },
    jumpLogin(tab) {
      this.$router.push({ path: "/loginPage", query: { tab } });
      location.reload();
    },
    outLogin() {
      this.$confirm("确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        outloginApi().then((res) => {
          this.$message({ message: res.message, type: "success" });
          const identity = localStorage.getItem("identity");
          this.$router.push({
            path: "/loginPage",
            query: { tab: identity == "admin" ? 2 : 0 },
          });
          localStorage.setItem("foregroundToken", "");
          localStorage.setItem("identity", "");
        });
      });
    },
    renew() {
      const tab = localStorage.getItem("tab");
      console.log("续费pc", tab);
      // code在pc端为null，在手机端传用户的code
      // type，如果是会员登录传member，如果是会员单位登录传memberUnits

      let type = "";
      if (tab === "0") {
        type = "member";
      }
      // else if (tab === "3") {
      //   type = "memberUnits";
      // } else {
      //   console.error("无效的tab值:", tab);
      //   return;
      // }

      renew({
        code: "",
        type: type,
      })
        .then((res) => {
          console.log("pcpcpc", res);
          if (res.code == 200) {
            this.dialogVisible = true;
            this.orderNo = res.data.orderNo;
            setTimeout(() => {
              new QRCode(this.$refs.qrCodeUrl, {
                text: res.data.url, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              let image = new Image();
              image.src =
                this.$refs.qrCodeUrl.firstChild.toDataURL("image/png");
              this.$refs.qrCodeUrl2.appendChild(image);
            }, 200);
          }
          // this.$message({ message: res.message, type: "success" });
        })
        .finally(() => {});
    },
     zhifuFun(){
        queryOrder({outTradeNo:this.orderNo}).then((res)=>{
          console.log("zhifuFun",res);
           if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
           }else{
              this.$message({ message: res.message, type: "info" });
           }
        }).finally(()=>{
        })
      },
    handleClose() {
      this.orderNo = "";
      this.dialogVisible = false;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
  <style scoped lang="css" src="../assets/css/rem.css" />
  <style>
.nav-tabbar .el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 0 29px;
  color: #000;
}
.nav-tabbar .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  margin: 0 29px;
  color: #000;
}
.nav-tabbar .el-dropdown-menu__item,
.el-menu-item {
  font-size: 18px !important;
  font-weight: 600;
  border: none;
  height: 50px !important;
  background-color: #ffffffb7;
}
.nav-tabbar .el-submenu__title {
  font-size: 18px !important;
  font-weight: 600;
  border: none;
}
.nav-tabbar .el-menu.el-menu--horizontal {
  border: none;
}
.nav-tabbar .el-menu--horizontal > .el-menu-item.is-active {
  /* border-bottom: 3px solid transparent */
  border-bottom: none !important;
  border-color: #fff !important;
}
.nav-tabbar .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  /* border-bottom: 3px solid transparent; */
  border-bottom: none !important;
  border-color: #fff !important;
}
.nav-tabbar .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none;
}

.menu-child {
  width: 100%;
  height: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}
</style>